import React from "react";
import './Loading.css'

function Loading() {
  return (
    <div className="loading">
      <h1>Generating a link for U</h1>
    </div>
  );
}

export default Loading;
